<template>
  <div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      :height="150"
      :width="150"
      :color="'#FFFF00'"
      :background-color="'#000000'"
      :opacity="0.5"
    ></loading>
    <v-container>
      <v-form ref="form">
        <v-row>
          <h2 class="pb-5">{{ this.parentObject.pageTitle }}</h2>
        </v-row>

        <v-container
          id="scroll-target"
          class="custom-form overflow-y-auto px-5"
        >
          <v-row>
            <v-col cols="6" sm="6" class="pb-n5">
              <v-text-field
                outlined
                label="Corporate ID"
                type="text"
                v-model="formData.corpid"
                maxlength="30"
                :rules="[rules.required]"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>

        <v-row>
          <div class="pt-5 pl-4 pb-4">
            <v-btn color="warning" style="width: 100px" @click="backHandler">
              {{$t('button.back')}}
            </v-btn>
          </div>
          <div class="pt-5 pl-4 pb-4">
            <v-btn color="warning" style="width: 100px" @click="getMaybankExportListHandler">
              {{$t('button.export')}}
            </v-btn>
          </div>
        </v-row>
      </v-form>
    </v-container>
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  props: {
    parentObject: Object,
  },

  components: {
    "app-error": ErrorDialog,
    Loading,
  },

  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
      },

      id: this.parentObject.id,
      data: this.parentObject.data,
      formData: {
        employername: '',
        debitacc: '',
        corpid: '',
      },

      titleData: null,

      totalAmtStfpcb: null,
      totalAmtCp38: null,

      accErr: [],
      taxdata: [],

      loading: false,

      processedCount: null,
      successCount: null,
      errCount: null,
      errMsg: "",
      isErr: false,
      isEdit: this.parentObject.isEdit,
    };
  },

  methods: {
    getMaybankExportListHandler() {
      if (!this.$refs.form.validate()) {
        this.isErr = true;
        this.errMsg = this.$t('vdatatable.someinfoismissing');
        return;
      }

      this.loading = true;
      const vm = this;

      let dateHolder2 = this.data.year + "-" + this.padRJ(this.data.month, 2) + "-" + this.daysInMonth(this.data.month, this.data.year);
      let date = moment(dateHolder2).format("YYYY-MM-DD");

      this.$store.dispatch('get', {
        url: `/ambanktaxexport/all/${this.$store.getters.userId}`
          + "/" + this.data.taxexprecid
          + "/" + this.data.refnum + "/" + date + "/" + date
      })
        .then(function (res) {
          vm.loading = false;
          vm.taxdata = res.data.rec;

          if (vm.taxdata.length > 0) {
            vm.formData.employername = vm.taxdata[0].compnyname || '';
            vm.formData.debitacc = vm.taxdata[0].debitaccountno || '';
          }

          if (!vm.formData.employername || !vm.formData.debitacc) {
            vm.isErr = true;
            vm.errMsg = 'No Company Bank Account is set up for this company (matched by company name in Company Bank Account Setup). Please configure one first.';
            return;
          }

          vm.exportHandler();
        })
        .catch(function (err) {
          vm.loading = false;
          vm.errMsg = err;
        });
    },

    buildHeader() {
      const batchid = "M" + moment().format("DDHHmmss");
      const refnum = String(this.data.refnum || "").replace(/[^0-9A-Za-z]/g, "").substring(0, 11);
      const monthYear = this.padRJ(this.data.month, 2) + this.data.year;
      const valuedate = moment().format("DDMMYYYY");

      const fields = new Array(42).fill("");
      fields[0] = "00";
      fields[1] = "Statutory Body";
      fields[2] = "4";
      fields[3] = "02";
      fields[4] = refnum;
      fields[5] = this.formData.employername;
      fields[6] = monthYear;
      fields[7] = this.formData.debitacc;
      fields[8] = valuedate;
      fields[9] = "2"; // Tax Payment Option: 2 - Employee Tax
      fields[20] = batchid;
      fields[21] = this.formData.corpid;
      return fields.join("|");
    },

    buildRecord(element) {
      const fields = new Array(136).fill("");
      const stfpcbholder = (element.stfpcb || 0).toFixed(2);
      const cp38holder = (element.cp38 || 0).toFixed(2);

      let refno = "SG00000000000";
      let wifecode = "";
      if (element.refno) {
        let digits = String(element.refno)
          .split("SG").join("")
          .split("OG").join("")
          .split("IG").join("")
          .split("-").join("")
          .split(" ").join("");
        let lastdigit = digits.substring(digits.length - 1, digits.length);
        if (parseInt(lastdigit) > 0) wifecode = lastdigit;
        digits = digits.substring(0, 11);
        while (digits.length < 11) digits = digits + "0";
        refno = "SG" + digits;
      }

      // New ID No / Passport No: use the employee's IC if they have one on
      // file, otherwise fall back to their passport number. Old ID No is
      // left blank (not needed once New ID No or Passport No is present).
      let newicno = "";
      let passportno = "";
      if (element.personidnotypeid == 1 && element.personidno) {
        newicno = String(element.personidno).replace(/[-\s]/g, "");
      } else if (element.personidnotypeid == 3 && element.personidno) {
        passportno = element.personidno;
      }

      fields[0] = "01";
      fields[1] = element.staffcode || "";
      fields[2] = "092";
      fields[4] = element.psnname || "";
      fields[5] = "Y";
      fields[7] = refno;
      fields[8] = newicno;
      fields[10] = passportno;
      fields[11] = stfpcbholder;
      fields[12] = cp38holder;
      fields[13] = wifecode;
      fields[14] = element.staffcode || "";
      return { text: fields.join("|"), stfpcb: element.stfpcb || 0, cp38: element.cp38 || 0 };
    },

    buildFooter(records) {
      let totalEmployee = 0;
      let totalEmployer = 0;
      let recEmployee = 0;
      let recEmployer = 0;

      records.forEach((r) => {
        totalEmployee += r.stfpcb;
        totalEmployer += r.cp38;
        if (r.stfpcb != 0) recEmployee++;
        if (r.cp38 != 0) recEmployer++;
      });

      this.totalAmtStfpcb = totalEmployee.toFixed(2);
      this.totalAmtCp38 = totalEmployer.toFixed(2);

      const fields = new Array(28).fill("");
      fields[0] = "99";
      fields[1] = totalEmployee.toFixed(2);
      fields[2] = totalEmployer.toFixed(2);
      fields[3] = String(recEmployee);
      fields[4] = String(recEmployer);
      fields[5] = String(records.length);
      fields[6] = (totalEmployee + totalEmployer).toFixed(2);
      return fields.join("|");
    },

    async getData() {
      const vm = this;
      let newtaxdetail = [];
      let dataholder = vm.taxdata;
      let taxdetail = this.filter(dataholder);

      this.processedCount = dataholder.length;
      this.successCount = taxdetail.length;
      this.errCount = dataholder.length - taxdetail.length;

      taxdetail.forEach(function (o) {
        var existing = newtaxdetail.filter(function (i) {
          return i.staffcode === o.staffcode;
        })[0];
        if (!existing) {
          newtaxdetail.push(o);
        } else {
          existing.stfpcb += o.stfpcb;
          existing.cp38 += o.cp38;
        }
      });

      const records = newtaxdetail.map((element) => this.buildRecord(element));

      if (records.length > 0) {
        this.titleData = this.padRJ(vm.data.month, 2) + "_" + vm.data.year + "_MAYBANK_TAX";
        const header = this.buildHeader();
        const footer = this.buildFooter(records);
        const lines = [header, ...records.map((r) => r.text), footer];
        this.download(lines.join("\n"), this.titleData);
      }
    },

    filter(item) {
      let checkdet = this.detailfilter(item);
      let checkactive = this.activefilter(checkdet);
      let checkpayment = this.paymentfilter(checkactive);
      return checkpayment;
    },

    detailfilter(item) {
      let dateHolder = this.data.year + "-" + this.padRJ(this.data.month, 2) + "-"
        + this.daysInMonth(this.data.month, this.data.year);
      let date = moment(dateHolder).format("YYYY-MM-DD");
      let dataitem = item.filter((e) => e.refnum == this.data.refnum);
      dataitem = dataitem.filter((e) => {
        return moment(e.startdate).format("YYYY-MM-DD") <= date && date <= moment(e.enddate).format("YYYY-MM-DD");
      });
      let noacc = item.filter((e) => !dataitem.includes(e));
      for (let i = 0; i < noacc.length; i++) {
        noacc[i].errormsg = this.$t('setupreport_exportmapping.nodetailinpersonstat');
        this.accErr.push(noacc[i]);
      }
      return dataitem;
    },

    activefilter(item) {
      let data = item.filter((e) => e.pystatcode == 'ACTIVE');
      let notactive = item.filter((e) => !data.includes(e));
      for (let i = 0; i < notactive.length; i++) {
        notactive[i].errormsg = this.$t('setupreport_exportmapping.paymentisnotactive');
        this.accErr.push(notactive[i]);
      }
      return data;
    },

    paymentfilter(item) {
      let data = item.filter((e) => {
        return (e.stfpcb || 0) != 0 || (e.cp38 || 0) != 0;
      });
      let nopayment = item.filter((e) => !data.includes(e));
      for (let i = 0; i < nopayment.length; i++) {
        nopayment[i].errormsg = this.$t('setupreport_exportmapping.nopayment');
        this.accErr.push(nopayment[i]);
      }
      return data;
    },

    download(data, title) {
      const blob = new Blob([data], { type: "text/plain;charset=utf-8" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute("download", title + ".txt");

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    padRJ(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    },

    exportHandler() {
      this.getData();
      let item = [];
      item.totalAmtstfpcb = this.totalAmtStfpcb;
      item.totalAmtcp38 = this.totalAmtCp38;
      item.accounterr = this.accErr;
      item.successCount = this.successCount;
      item.processedCount = this.processedCount;
      item.errCount = this.errCount;

      if (!this.isErr) {
        this.$router.push({ name: "monthlytaxexportlog", params: { item } });
      }
    },

    backHandler() {
      this.$router.push({ name: "monthlytaxexport" });
    },

    daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    },
  },

  mounted() {
  },
};
</script>

<style scoped>
</style>
